import { DialogService } from '@sdbn/common';

import { RegistrationStepperModel } from './../model/registration-step-model';
import { ResponseStatus } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';
import { TransportRegistrationIdentity } from '../model/out/transport-registration-identity';
import { TransportRegistration } from '../model/transport-registration';
import { TransportRegistrationService } from '../service/transport-registration.service';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { AppClientConfigurationService } from '@sdbn/common';
import { TransportManagementLevel, TransportPlanningType } from '../../../common/model/transport.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';


@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

  TransportManagementLevel = TransportManagementLevel;
  TransportPlanningType = TransportPlanningType;

  vehicleId: number;

  choosenRegisterEntrance = false;

  readonly = true;

  stepperModel: RegistrationStepperModel = new RegistrationStepperModel();

  isLoading = false;

  registration = new TransportRegistration();

  responseMessages: ResponseMessage[];

  initialFieldValue: string;

  updatingEnablement = false;
  changingValues = false;

  formGroup = new FormGroup({
    registerArrival: new FormControl(null, []),
    registerEntrance: new FormControl(null, [])
  });

  constructor(
    public dialogRef: MatDialogRef<RegistrationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private registrationService: TransportRegistrationService,
    public dialog: MatDialog,

    public translationService: TranslationService,
    public configurationService: AppClientConfigurationService,
    private dialogService: DialogService
  ) {

    this.vehicleId = data.vehicleId;

    this.stepperModel.componentTitles.push('tmc-yard.ui.transport.registration.step.registration.title');
    this.stepperModel.componentTitles.push('tmc-yard.entity.transport.options');
    this.stepperModel.componentTitles.push('tmc-yard.ui.transport.registration.step.route.title');
    this.stepperModel.componentTitles.push('tmc-yard.ui.transport.registration.step.supplementary-equipment.title');
    this.stepperModel.numberOfSteps = this.stepperModel.componentTitles.length;

    this.choosenRegisterEntrance = this.configurationService.isPropertyTrue(TMCClientParameters.P_VISITOVERVIEW_REGISTER_REGISTER_ENTRANCE_VALUE, false);
    this.formGroup.patchValue({ registerEntrance: this.choosenRegisterEntrance });

  }

  ngOnInit() {
    this.isLoading = true;

    const request = new TransportRegistrationIdentity();
    request.vehicleId = this.vehicleId;

    this.registrationService.getNewRegistration(request).subscribe(
      result => {
        let registration = new TransportRegistration(result);
        this.updateInitialValue(registration, this.data.filterValue);
        this.registration = registration;
        console.log('registration is', this.registration);
        this.updateCheckboxes();

        this.readonly = false;
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      }
    );

    this.formGroup.valueChanges.subscribe(value => {

      if (this.updatingEnablement || this.changingValues) {
        return;
      }

      this.changingValues = true;

      if (this.registration != null) {
        this.registration.registerNow = value.registerArrival;
        if (this.formGroup.controls['registerEntrance'].enabled) {
          this.choosenRegisterEntrance = value.registerEntrance;
        }
      }

      this.updateCheckboxes();

      this.changingValues = false;

    });
  }

  private updateCheckboxes() {

    if (this.registration == null) {
      return;
    }

    this.updatingEnablement = true;

    console.log('updating checkboxes', this.registration.transport.timing.planningType, this.registration.registerNow)

    if (this.registration.transport.timing.planningType === TransportPlanningType.DEFAULT) {

      this.formGroup.controls['registerArrival'].disable();
      this.formGroup.controls['registerEntrance'].enable();

    } else {

      this.formGroup.controls['registerArrival'].enable();

      if (this.registration.registerNow) {
        this.formGroup.controls['registerEntrance'].enable();
        this.formGroup.patchValue({ registerArrival: this.registration.registerNow, registerEntrance: this.choosenRegisterEntrance });
      } else {
        this.formGroup.controls['registerEntrance'].disable();
        this.formGroup.patchValue({ registerArrival: this.registration.registerNow, registerEntrance: false });
      }

    }

    this.updatingEnablement = false;
  }

  private updateInitialValue(registration: TransportRegistration, value: string) {

    console.log('updating initial values', this.configurationService.getPropertyValue(TMCClientParameters.P_VISITS_TRANSPORT_REGISTER_SEARCH_VALUE_DESTINATION, ''), value);

    if (this.vehicleId != null) {
      return;
    }

    const dest = this.configurationService.getPropertyValue(TMCClientParameters.P_VISITS_TRANSPORT_REGISTER_SEARCH_VALUE_DESTINATION, '');
    if (dest === 'carrier') {
      registration.transport.masterdata.carrier = value;
    } else if (dest === 'name') {
      registration.transport.masterdata.driverName = value;
    } else if (dest === 'coDriver') {
      registration.transport.masterdata.coDriver = value;
    } else if (dest === 'numberPlate') {
      registration.transport.masterdata.numberPlate = value;
    } else if (dest === 'swapTrailerNumber') {
      registration.transport.masterdata.firstLoadCarrier.swapTrailerNumber = value;
    } else if (dest === 'orderReference') {
      registration.transport.masterdata.firstLoadCarrier.orderReference = value;
    } else if (dest === 'string1') {
      registration.transport.masterdata.string1 = value;
    } else if (dest === 'string2') {
      registration.transport.masterdata.string2 = value;
    }
  }

  isSaveDisabled() {
    if (this.isLoading) {
      return true;
    }
    return true;
  }

  cancel() {
    this.dialogRef.close();
  }

  finish() {

    const noMessagingProviderSelected = !this.registration.transport.messaging.useGlobalConnect && !this.registration.transport.messaging.useSms && !this.registration;
    const automaticStartRouteActive = this.configurationService.isPropertyTrue('automatization.route.start.processing.active', false);
    const messagingRequired = this.configurationService.isPropertyTrue('automatization.route.start.processing.messagingrequired', false);

    // Hinweisdialog falls kein MessagingProvider selektiert aber der automatische Abruf aktiv und der Provider nicht benötigt
    if (noMessagingProviderSelected && automaticStartRouteActive && !messagingRequired) {

      this.dialogService.showConfirm(
        'tmc-yard.ui.transport.registration.no-messaging-provider.confirm-dialog.title',
        'tmc-yard.ui.transport.registration.no-messaging-provider.confirm-dialog.message'
      ).afterClosed().subscribe(result => {
        if (result) {
          this.executeFinish();
        }
      });
    } else {
      this.executeFinish();
    }

  }

  executeFinish() {
    this.responseMessages = [];

    this.isLoading = true;

    this.registrationService.save(new TransportRegistration(this.registration)).subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {

        if (this.formGroup.value.registerEntrance) {
          this.dialogRef.close({ action: 'registerTransport', transportId: response.transportId });
        } else {
          this.dialogRef.close({ action: 'selectTransport', transportId: response.transportId });
        }
      } else {
        this.responseMessages = response.responseMessages;
      }

      this.isLoading = false;
    }, error => {
      console.log(error);
      this.isLoading = false;
    });
  }

  showPreviousStep() {
    if (this.stepperModel.currentComponentIndex >= 1) {
      if (this.registration.transport.masterdata.managementLevel === TransportManagementLevel.LIFECYCLE
        && this.stepperModel.currentComponentIndex === 3) {
        this.stepperModel.currentComponentIndex = this.stepperModel.currentComponentIndex - 2;
      } else {
        this.stepperModel.currentComponentIndex = this.stepperModel.currentComponentIndex - 1;
      }
    }
  }

  showNextStep() {

    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.stepperModel.beforeShowNextStep().subscribe(
      next => {
        try {
          if (next === true) {
            if (this.registration.transport.masterdata.managementLevel === TransportManagementLevel.LIFECYCLE
              && this.stepperModel.currentComponentIndex === 1) {
              this.stepperModel.currentComponentIndex = this.stepperModel.currentComponentIndex + 2;
            } else {
              this.stepperModel.currentComponentIndex = this.stepperModel.currentComponentIndex + 1;
            }
          }
        } catch (e) {
          console.log(e);
          this.isLoading = false;
        }
        finally {
          this.isLoading = false;
        }
      },
      error => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }

  stepCompleted() {
    if (this.stepperModel.stepCompleted) {
      return this.stepperModel.stepCompleted();
    }
    return false;
  }

  isPreviousStepVisible() {
    return this.stepperModel.currentComponentIndex > 0;
  }

  showNextStepButtonVisible() {
    return this.stepperModel.currentComponentIndex + 1 < this.stepperModel.numberOfSteps;
  }

  showFinishButtonVisible() {
    return this.stepperModel.currentComponentIndex + 1 === this.stepperModel.numberOfSteps;
  }

  isCancelDisabled() {
    if (this.isLoading) {
      return true;
    }
    return false;
  }

  showPreviousStepDisabled() {
    if (this.isLoading) {
      return true;
    }
    return false;
  }

  showNextStepDisabled() {

    if (this.isLoading) {
      return true;
    }

    if (!this.stepCompleted()) {
      return true;
    }

    return false;
  }

  finishDisabled() {

    if (this.isLoading) {
      return true;
    }

    if (!this.stepCompleted()) {
      return true;
    }

    return false;
  }

  handleValueChange() {
    this.updateCheckboxes();
  }
}
